import React, { useContext } from "react";
import PropTypes from "prop-types";

import DataTable from "../../../../components/DataTable";

import {
  ALL_EMPLOYEE_CERTIFICATIONS_QUERY,
  EMPLOYEE_CERTIFICATIONS_PAGINATION_QUERY
} from "../../../../graphql/EmployeeCertifications/EmployeeCertifications.graphql";

import { EditEmployeeCertificationForm } from "../../../../components/Employees";

import { ModalContext } from "../../../../components/ModalProvider";

import { CERTIFICATION_COLUMNS } from "../columns";

function Certifications({ employeeRecId, isDispatcher }) {
  const { setModalOpen } = useContext(ModalContext);
  return (
    <DataTable
      columns={CERTIFICATION_COLUMNS}
      dataQuery={ALL_EMPLOYEE_CERTIFICATIONS_QUERY}
      initialSortBy={[
        { id: "ExpirationDate", desc: false },
        { id: "Type", desc: false }
      ]}
      name="EmployeeCertification"
      paginationQuery={EMPLOYEE_CERTIFICATIONS_PAGINATION_QUERY}
      where={{ EmployeeRecIdRef: parseInt(employeeRecId) }}
      onRowClick={
        isDispatcher
          ? () => null
          : certification =>
              setModalOpen(
                true,
                <EditEmployeeCertificationForm
                  certification={certification}
                  onComplete={() => setModalOpen(false, "")}
                />
              )
      }
    />
  );
}

Certifications.propTypes = {
  employeeRecId: PropTypes.number,
  isDispatcher: PropTypes.bool
};

Certifications.defaultProps = {
  employeeRecId: 0,
  isDispatcher: false
};
export default Certifications;
